/* eslint-disable */
export const States = [
  { id: 'Alabama', name: 'Alabama', code: 'AL' },
  { id: 'Alaska', name: 'Alaska', code: 'AK' },
  { id: 'Arizona', name: 'Arizona', code: 'AZ' },
  { id: 'Arkansas', name: 'Arkansas', code: 'AR' },
  { id: 'California', name: 'California', code: 'CA' },
  { id: 'Colorado', name: 'Colorado', code: 'CO' },
  { id: 'Connecticut', name: 'Connecticut', code: 'CT' },
  { id: 'Delaware', name: 'Delaware', code: 'DE' },
  { id: 'District_of_Columbia', name: 'District of Columbia', code: 'DC' },
  { id: 'Florida', name: 'Florida', code: 'FL' },
  { id: 'Georgia', name: 'Georgia', code: 'GA' },
  { id: 'Hawaii', name: 'Hawaii', code: 'HI' },
  { id: 'Idaho', name: 'Idaho', code: 'ID' },
  { id: 'Illinois', name: 'Illinois', code: 'IL' },
  { id: 'Indiana', name: 'Indiana', code: 'IN' },
  { id: 'Iowa', name: 'Iowa', code: 'IA' },
  { id: 'Kansas', name: 'Kansas', code: 'KS' },
  { id: 'Kentucky', name: 'Kentucky', code: 'KY' },
  { id: 'Louisiana', name: 'Louisiana', code: 'LA' },
  { id: 'Maine', name: 'Maine', code: 'ME' },
  { id: 'Maryland', name: 'Maryland', code: 'MD' },
  { id: 'Massachusetts', name: 'Massachusetts', code: 'MA' },
  { id: 'Michigan', name: 'Michigan', code: 'MI' },
  { id: 'Minnesota', name: 'Minnesota', code: 'MN' },
  { id: 'Mississippi', name: 'Mississippi', code: 'MS' },
  { id: 'Missouri', name: 'Missouri', code: 'MO' },
  { id: 'Montana', name: 'Montana', code: 'MT' },
  { id: 'Nebraska', name: 'Nebraska', code: 'NE' },
  { id: 'Nevada', name: 'Nevada', code: 'NV' },
  { id: 'New_Hampshire', name: 'New Hampshire', code: 'NH' },
  { id: 'New_Jersey', name: 'New Jersey', code: 'NJ' },
  { id: 'New_Mexico', name: 'New Mexico', code: 'NM' },
  { id: 'New_York', name: 'New York', code: 'NY' },
  { id: 'North_Carolina', name: 'North Carolina', code: 'NC' },
  { id: 'North_Dakota', name: 'North Dakota', code: 'ND' },
  { id: 'Ohio', name: 'Ohio', code: 'OH' },
  { id: 'Oklahoma', name: 'Oklahoma', code: 'OK' },
  { id: 'Oregon', name: 'Oregon', code: 'OR' },
  { id: 'Pennsylvania', name: 'Pennsylvania', code: 'PA' },
  { id: 'Puerto_Rico', name: 'Puerto Rico', code: 'PR' },
  { id: 'Rhode_Island', name: 'Rhode Island', code: 'RI' },
  { id: 'South_Carolina', name: 'South Carolina', code: 'SC' },
  { id: 'South_Dakota', name: 'South Dakota', code: 'SD' },
  { id: 'Tennessee', name: 'Tennessee', code: 'TN' },
  { id: 'Texas', name: 'Texas', code: 'TX' },
  { id: 'U.S._Armed_Forces_Americas', name: 'U.S. Armed Forces – Americas', code: 'AA' },
  { id: 'U.S._Armed_Forces_Africa_Canada_Europe_Middle_East', name: 'U.S. Armed Forces – Africa / Canada / Europe / Middle East', code: 'AE' },
  { id: 'U.S._Armed_Forces_Pacific', name: 'U.S. Armed Forces – Pacific', code: 'AP' },
  { id: 'Utah', name: 'Utah', code: 'UT' },
  { id: 'Vermont', name: 'Vermont', code: 'VT' },
  { id: 'Virginia', name: 'Virginia', code: 'VA' },
  { id: 'Washington', name: 'Washington', code: 'WA' },
  { id: 'West_Virginia', name: 'West Virginia', code: 'WV' },
  { id: 'Wisconsin', name: 'Wisconsin', code: 'WI' },
  { id: 'Wyoming', name: 'Wyoming', code: 'WY' }
]